import React from 'react';
export function Bonuses() {
  const bonuses = [{
    num: 1,
    title: 'Copy Swipe File',
    desc: '47 ángulos de venta probados. Listos para copiar, pegar y convertir. Sin bloqueo creativo.',
    value: '$148.500 ARS'
  }, {
    num: 2,
    title: 'Meta Ads Blueprint',
    desc: 'Estructura exacta que genera 3-8:1 ROAS. Paso a paso desde cero. Probada y documentada.',
    value: '$223.500 ARS'
  }, {
    num: 3,
    title: 'ROAS Calculator',
    desc: 'Google Sheets interactiva. Calcula tus ganancias automáticamente. 30 plantillas pre-cargadas.',
    value: '$298.500 ARS'
  }, {
    num: 4,
    title: 'Video Masterclass',
    desc: '15 minutos. Los 7 secretos de Meta Ads que Meta no quiere que sepas. Grabado y listo.',
    value: '$145.500 ARS'
  }, {
    num: 5,
    title: '30 Productos Probados',
    desc: 'Con márgenes, proveedores verificados, copy ganador y ROAS esperado. Listo para escalar.',
    value: '$298.500 ARS'
  }];
  return <section className="py-20 px-4" data-id="element-1">
      <div className="max-w-[1200px] mx-auto" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-[2.5rem] font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#00d4ff] to-[#00ff88] mb-4 uppercase" data-id="element-4">
            + 5 BONOS EXCLUSIVOS DE ALTO VALOR
          </h2>
          <p className="text-lg text-[#e0e0e0] font-light" data-id="element-5">
            Valor total: $1.114.500 ARS — Hoy gratis con tu compra
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-6">
          {bonuses.map((bono, idx) => <div key={idx} className="relative bg-gradient-to-br from-[#00d4ff]/[0.08] to-[#ff006e]/[0.05] border-2 border-[#00d4ff]/30 rounded-xl p-8 transition-all duration-300 hover:-translate-y-[10px] hover:border-[#00d4ff] hover:shadow-[0_20px_40px_rgba(0,212,255,0.2)] group overflow-hidden" data-id="element-7">
              {/* Top Gradient Border */}
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#00d4ff] via-[#ff006e] to-[#00ff88]" data-id="element-8"></div>

              <div className="w-10 h-10 bg-[#00d4ff] rounded-full flex items-center justify-center text-[#1a1a2e] font-bold text-xl mb-6" data-id="element-9">
                {bono.num}
              </div>

              <h3 className="text-xl font-bold text-[#00d4ff] mb-3" data-id="element-10">
                {bono.title}
              </h3>

              <p className="text-[0.95rem] text-[#e0e0e0]/90 leading-relaxed mb-6" data-id="element-11">
                {bono.desc}
              </p>

              <div className="mt-auto pt-4 border-t border-[#00d4ff]/20" data-id="element-12">
                <p className="text-[0.9rem] text-[#00ff88] font-bold" data-id="element-13">
                  💰 Valor: {bono.value}
                </p>
              </div>
            </div>)}
        </div>

        {/* Comparison Box */}
        <div className="mt-16 max-w-3xl mx-auto bg-[#00d4ff]/5 border-2 border-dashed border-[#00d4ff] rounded-xl p-8 md:p-10 text-center" data-id="element-14">
          <p className="text-[0.9rem] text-[#888] font-medium uppercase tracking-wider mb-2" data-id="element-15">
            PRECIO NORMAL DEL EBOOK:
          </p>
          <p className="text-2xl font-bold text-[#888] line-through mb-6" data-id="element-16">
            <span className="text-red-500" data-id="element-17">$340.000 ARS</span>
          </p>

          <p className="text-[0.9rem] text-[#888] font-medium uppercase tracking-wider mb-2" data-id="element-18">
            HOY CON LOS 5 BONOS INCLUIDOS:
          </p>
          <p className="text-4xl md:text-5xl font-black text-[#00ff88] mb-4" data-id="element-19">
            $14.990 ARS
          </p>

          <p className="text-[0.85rem] md:text-sm text-[#00d4ff] font-bold uppercase tracking-wide" data-id="element-20">
            AHORRAS: $15.000 ARS (50% OFF) + $1.114.500 ARS EN BONOS
          </p>
        </div>
      </div>
    </section>;
}